import { Grid, Typography, withStyles } from "@material-ui/core";
import { Button, InputField, Modale, Snack } from "bc-front-sagacomponents";
import { FormProvider } from "react-hook-form";
import styles from "../../style";
import { useAjoutAdherent } from "./selectors";

interface Props {
  classes?: any;
  openAjoutAdherent: boolean;
  setOpenAjoutAdherent(param: boolean): void;
}
const AjoutAdherent = (props: Props) => {
  const { classes, openAjoutAdherent, setOpenAjoutAdherent } = props;

  const {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    onSubmit,
    fetching,
    errorApi,
    setErrorApi,
    confirmationAjoutAdherent,
    setConfirmationAjoutAdherent,
  } = useAjoutAdherent(setOpenAjoutAdherent);

  const handleChange = () => {
    setErrorApi(undefined);
  };
  return (
    <>
      {" "}
      {confirmationAjoutAdherent && (
        <Snack
          type="success"
          message="Le contrat a bien été ajouté. Pour que les modifications soient visibles merci de vous déconnecter et vous reconnecter"
          onClose={() => setConfirmationAjoutAdherent(false)}
        />
      )}
      <Modale
        open={openAjoutAdherent}
        onCancel={() => setOpenAjoutAdherent(false)}
        title=" "
      >
        <Grid item className={classes.modaleAjoutAdherent}>
          <Typography variant="h3">Ajouter un contrat</Typography>
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <InputField
                name="numeroAdhesion"
                label="N° d'adhésion"
                onChange={handleChange}
                required
                pattern={{
                  value: /^\d+$/,
                  message:
                    "Merci de saisir un numéro d'adhésion valide (seulement des chiffres)",
                }}
                value={watch("numeroAdhesion")}
                errors={errors.numeroAdhesion}
                register={register}
              />{" "}
              {errorApi &&
                errorApi.response &&
                errorApi.response.data.description && (
                  <Typography color="error" variant="body2">
                    {errorApi.response.data.description}
                  </Typography>
                )}{" "}
              {errorApi &&
                ((errorApi.response && !errorApi.response.data.description) ||
                  !errorApi.response) && (
                  <Typography color="error" variant="body2">
                    Une erreur est survenue
                  </Typography>
                )}
              <Button
                variant="contained"
                color="primary"
                title={"Valider"}
                type="submit"
                fetching={fetching}
              ></Button>
            </form>
          </FormProvider>
        </Grid>
      </Modale>
    </>
  );
};

export default withStyles(styles)(AjoutAdherent);
